import { render, staticRenderFns } from "./DeleteGroupPopup.vue?vue&type=template&id=88218558&"
import script from "./DeleteGroupPopup.vue?vue&type=script&lang=js&"
export * from "./DeleteGroupPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports